export default __webpack_public_path__ + "static/media/PersonswithDisabilities_en.0bbf93e7.svg";